module.exports = __webpack_public_path__ + "img/podles.b4e79fcd.jpg";